// THE SCROLLBAR'S WIDTH, as a CSS custom property.
//
// Some layouts have to subtract it in CSS: the planning grids floor their width
// at the CONTAINER's width (`100cqw` — so the calendar keeps its cell widths and
// scrolls rather than shrinking when a panel takes room), and a container query
// cannot see the vertical scrollbar living inside the scrollport. Without the
// subtraction the floor overshoots the usable width by exactly one bar, and the
// board scrolls sideways forever with its last day half off the screen.
//
// CSS has no unit for it, so it is measured — ONCE: no observers, no
// per-component state, one number on :root that any layout can read.
//
// ⚰ No planning surface reserves its gutter (`scrollbar-gutter: stable`) any
// more. A reserved gutter keeps the usable width identical whether or not a bar
// is showing — but it also holds that lane open when there is no bar, and every
// rule in the grid then stops one bar short of the card's own frame (his QA, on
// the month first and the week after). The subtraction is a FLOOR, so leaving
// the gutter off is safe in both states: with no bar the floor undershoots by
// one and simply stops binding, and `width: 100%` stretches to fill; with a bar
// the floor is exactly the usable width. It is a floor that OVERSHOOTS that
// hurts — that is the sideways scroll above.
export const SCROLLBAR_WIDTH_VAR = '--scrollbar-w'

function measure(): number {
  const probe = document.createElement('div')
  probe.style.cssText = 'position:absolute;top:-9999px;width:100px;height:100px;overflow:scroll'
  document.body.appendChild(probe)
  const width = probe.offsetWidth - probe.clientWidth
  probe.remove()
  return width
}

// Re-measured on resize for one reason only: browser zoom scales the scrollbar,
// and a page at 150 % would otherwise keep the 100 % number. Cheap enough to be
// unconditional — one property write, no layout read beyond the probe.
export function installScrollbarWidth(): void {
  const apply = () => {
    document.documentElement.style.setProperty(SCROLLBAR_WIDTH_VAR, `${measure()}px`)
  }
  apply()
  window.addEventListener('resize', apply)
}
